export default __webpack_public_path__ + "static/sell-a4468e0510d64ea8be0cbb13b8232bd5.svg";